// @flow

import * as React from 'react';
import classnames from 'classnames';

import Button, { type Props as ButtonProps } from './Button';
import FontAwesomeIcon, {
  type Icon,
  type AllowedModifier
} from 'common/components/FontAwesomeIcon';

import styles from './IconButton.module.scss';

type IconButtonProps = {
  icon: Icon,
  children: React.Node,
  iconPosition?: 'left' | 'right',
  iconSpin?: boolean,
  iconPulse?: boolean,
  ...
} & ButtonProps;

export default function IconButton(props: IconButtonProps): React.Node {
  const {
    icon,
    children,
    iconPosition = 'right',
    iconSpin = false,
    iconPulse = false,
    ...otherProps
  } = props;

  const modifier: Array<AllowedModifier> = [];
  if (iconSpin) modifier.push('spin');
  if (iconPulse) modifier.push('spin-pulse');

  const leftOrRightIcon = (
    <FontAwesomeIcon
      icon={icon}
      className={classnames({
        [styles.icon]: true,
        [styles.left]: iconPosition === 'left',
        [styles.right]: iconPosition === 'right',
        [styles.spin]: iconSpin,
        [styles.pulse]: iconPulse
      })}
      modifier={modifier}
    />
  );

  return (
    <Button {...otherProps}>
      {iconPosition === 'left' ? leftOrRightIcon : null}
      {children}
      {iconPosition === 'right' ? leftOrRightIcon : null}
    </Button>
  );
}
